/*
 * Mercado — RTL bridge for Slick sliders.
 * Loaded (deferred) after vendor.js and before theme.js.
 * Lushy only passes `rtl: theme.rtl` to some of its Slick sliders; others (e.g. the
 * product gallery) are initialised LTR, which breaks under <html dir="rtl">.
 * On RTL pages this makes every new Slick instance default to rtl: true.
 */
(function () {
  var $ = window.jQuery;
  if (!$ || !$.fn || typeof $.fn.slick !== 'function') return;
  if (document.documentElement.getAttribute('dir') !== 'rtl') return;

  var originalSlick = $.fn.slick;
  var patchedSlick = function () {
    var args = Array.prototype.slice.call(arguments);
    var isInit = args.length === 0 || (typeof args[0] === 'object' && args[0] !== null);
    if (isInit) {
      args[0] = $.extend({}, args[0] || {}, { rtl: true });
    }
    return originalSlick.apply(this, args);
  };
  for (var key in originalSlick) {
    if (Object.prototype.hasOwnProperty.call(originalSlick, key)) patchedSlick[key] = originalSlick[key];
  }
  $.fn.slick = patchedSlick;
})();
